
export default function (Component) {
  Component.options.__source = "src/components/filter-select/index.vue"
}
